import React, { Component, Fragment } from "react";
import { Graphics, Text, withPixiApp } from "@inlet/react-pixi";
import withAutoplayKeyboardListenerConfiguration from "./configuration/withAutoplayKeyboardListenerConfiguration";

import * as PIXI from "pixi.js";

import { connect } from "react-redux";

import { Dispatch } from "redux";



import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';

import "react-toggle/style.css"
import { isMobile } from "react-device-detect";
// import { actions as buttonActions } from "../../reducers/buttonPanelReducer";

// import { actions as asyncActions } from "../../reducers/asyncServerResponseReducer";

import KeyboardEventHandler from 'react-keyboard-event-handler';
import { actions as autoplayKeyboardListenerAction } from "../../gamereducer/autoplayKeyboardListenerReducer";
// import { configGame } from "../../../data/config";
// import { actions as reelsActions } from "../../reducers/reelsStateReducer";
// import { actions as gridsActions } from "../../reducers/gridStateReducer";
// import { actions as reelsGridActions } from "../../reducers/reelgridStateReducer";
// import { TIMER } from "../../utills";
interface IStore {
    [x: string]: any;
}
interface IProps {
    [x: string]: any;
}

interface IState {

}

interface IState {
    isGameLoaded: boolean,
    enableOk: boolean,
    width: number | string,
    height: number | string,
    pixelRatio: number,
    buttonSelected: any,
    selectedautoplayCount: number,
    toggleOn: boolean,


}

interface IStateToProps {
}

interface IDispatchToProps {
}

class AutoplayKeyboardListener extends Component<IProps, IState> {
    protected app: PIXI.Application;

    protected AutoplayKeyboardListener: any;
    protected variableToStoreNumber: any = "";


    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.AutoplayKeyboardListener = React.createRef();
        this.state = {
            width: this.props.width,
            height: this.props.height,
            buttonSelected: "",
            selectedautoplayCount: 0,
            pixelRatio: 1,
            enableOk: false,
            isGameLoaded: false,
            toggleOn: true

        }

    }

    reset() {
        this.props.setValueOfNumberButton(0)
        this.setState((prevState) => {
            return {
                ...prevState,
                buttonSelected: "",
                enableOk: false,

            }
        })
    }


    updateDimensions = () => {
        this.setState((prevState) => {
            return {
                ...prevState,
                width: isMobile && window.screen.availWidth || window.innerWidth,
                height: isMobile && window.screen.availHeight || window.innerHeight,
                pixelRatio: window.devicePixelRatio
            }
        })
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        this.updateDimensions();

    }


    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }


    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextProps.autoplayKeyboardListenerActive  && nextProps.autoplayKeyboardListenerActive !== this.props.autoplayKeyboardListenerActive) {
            return true;
        }
        if (nextProps.clickedInputBox !== this.props.clickedInputBox ) {
            this.variableToStoreNumber = '';

            return false;
        }
        return true;
    }


    makeDigitToVisible(digit: any) {


        if (digit == "Backspace") {
            let count = this.variableToStoreNumber;

            if (count.length <= 1 || count.length == undefined) {
                this.variableToStoreNumber = 0;
            }
            else {
                this.variableToStoreNumber = this.variableToStoreNumber.substring(0, this.variableToStoreNumber.length - 1);

            }

        }
        else {
            this.variableToStoreNumber = this.variableToStoreNumber + digit;
        }
        // let digitInInt=this.variableToStoreNumber.parseInt()

        this.props.setDigitToDisplay(parseFloat(this.variableToStoreNumber));

    }
    render() {
        if (!this.props.autoplayKeyboardListenerActive) {
            return (<></>)
        }
        return (
            <div>
                <KeyboardEventHandler
                    handleKeys={['1', "2", "3", "4", "5", "6", "7", "8", "9", "0", "backSpace"]}
                    onKeyEvent={(key, e) => {
                        this.makeDigitToVisible(e.key);

                    }} />
            </div>
        )
    }
}


export default withPixiApp(connect(
    (state: Pick<IStore, 'autoplayKeyBoardListenerState' | 'freegameState' | 'desktopSettingPanelState' | 'basegameState' | 'winpresentationState' | 'applicationState' | 'gridsState' | 'reelgridState' | 'reelsState' | 'keyboardListenerState'>): IStateToProps =>
    ({
        autoplayKeyboardListenerActive: state.autoplayKeyBoardListenerState.autoplayKeyboardListenerActive,
        clickedInputBox: state.autoplayKeyBoardListenerState.clickedInputBox,
        // inFreeGame: state.freegameState.inFreeGame,
        // scaleY: state.applicationState.scaleY,
        // spinWithSpaceBar: state.keyboardListenerState.spinWithSpaceBar,
        // winCelebrationForKeyBoardListener: state.keyboardListenerState.winCelebrationForKeyBoardListener,
        // winPresentationStart: state.winpresentationState.winPresentationStart,
        // showSettingPanelUI: state.desktopSettingPanelState.showSettingPanel,
        // phaseCount: state.winpresentationState.phaseCount,
        // allSpinComplete: configGame["SPIN_TYPE"] === 1 && state.gridsState.allSpinComplete || configGame["SPIN_TYPE"] === 2 && state.reelgridState.allSpinComplete || configGame["SPIN_TYPE"] === 0 && state.reelsState.allSpinComplete,
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        // getApplicationSpinResponse: (): any => dispatch(asyncActions.getApplicationSpinResponse()),
        // setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
        // resetReelState: (): any => dispatch(configGame["SPIN_TYPE"] === 0 && reelsActions.resetReelState() || configGame["SPIN_TYPE"] === 1 && gridsActions.resetReelState() || configGame["SPIN_TYPE"] === 2 && reelsGridActions.resetReelState()),
        // stopWinPresentation: (): any => dispatch(winpresentationAction.stopWinPresentation()),
        // setPhaseCount: (phasecount: number): any => dispatch(winpresentationAction.setPhaseCount(phasecount)),
        setDigitToDisplay: (digitToDisplay: any): any => dispatch(autoplayKeyboardListenerAction.setDigitToDisplay(digitToDisplay)),


    }))(withAutoplayKeyboardListenerConfiguration(AutoplayKeyboardListener)));